export const CREDIT_PROGRAM_GIFT_CARDS = ['DataCandy', 'Givex', 'Worldpay'];

export const isGiftCard = () => {
    const {
        headoffice: { credit_program: { enabled, scheme_id } = {} } = {},
    } = Mobi2Go;
    return enabled && CREDIT_PROGRAM_GIFT_CARDS.includes(scheme_id);
};

export const isGiftCardEmpty = (customer) =>
    customer?.isLoggedIn() &&
    isGiftCard() &&
    customer.getCreditBalance()[0] === 0;
